import * as React from "react";

function SvgUsage(props) {
  return (
    <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width={19.1} height={16.472} {...props}>
        <g data-name="Group 10798" stroke="#fff" strokeWidth={0.2}>
          <path
            data-name="Path 43198"
            d="M.891 12.706a.792.792 0 00.55-.221l5.922-5.679 1.853 1.793a1.292 1.292 0 001.8.006l6.069-5.8v2.717a.795.795 0 001.589 0V1.247A1.152 1.152 0 0017.523.096h-4.256a.795.795 0 000 1.589h2.69l-5.835 5.572-1.854-1.794a1.292 1.292 0 00-1.8 0L.342 11.337a.795.795 0 00.55 1.368z"
          />
          <path data-name="Path 43199" d="M18.205 14.783H.89a.795.795 0 000 1.589h17.311a.795.795 0 100-1.589z" />
        </g>
      </svg>
    </span>
  );
}

export default SvgUsage;
